import React from 'react';
import { processLink } from '../../shared/processLink';
import { ReachButton } from '../ReachButton/ReachButton';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
import './ArticleLinks.scss';

export const ArticleLinks = ({ node }) => {
    const downloadLink = node.relationships?.field_media;
    const pathLink = node.field_link;
    if (!downloadLink && !pathLink) {
        return (
            <p className="component-error">
                Please set text fields in CMS: {node.type}
            </p>
        );
    }
    return (
        <ParentNodeProvider nodeName={undefined} nodeType="Article_Links">
            <div className="article-links">
                {downloadLink && (
                    <ReachButton
                        href={
                            downloadLink.relationships?.field_media_document
                                ?.localFile?.publicURL
                        }
                        buttonStyle="borderless"
                        buttonIcon={{
                            icon: `ki-download`,
                            position: `right`,
                        }}
                        download
                    >
                        {!node.field_button_text
                            ? `Download`
                            : node.field_button_text}
                    </ReachButton>
                )}
                {node.field_link.map((link, idx) => (
                    <ReachButton
                        href={processLink(link.uri)}
                        buttonStyle="borderless"
                        buttonIcon={{
                            icon: `ki-arrow-right`,
                            position: `right`,
                        }}
                        key={idx}
                    >
                        {link.title}
                    </ReachButton>
                ))}
            </div>
        </ParentNodeProvider>
    );
};
